import * as React from "react";
const SvgFiRrDrumstickBite = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-drumstick-bite_svg__a)">
      <path
        fill="#062147"
        d="M21.499 2.501A8.48 8.48 0 0 0 15.462 0c-2.28 0-4.425.888-6.038 2.501-2.377 2.377-3.156 7.909-3.41 10.995a4.17 4.17 0 0 0 .582 2.495l-3.783 3.783a1.5 1.5 0 1 0-.666 2.08 1.5 1.5 0 1 0 2.081-.666l3.784-3.783a4.2 4.2 0 0 0 2.148.596c1.111.003 3.299-.306 5.115-.69a1 1 0 0 0 .785-1.107 5 5 0 0 1-.051-.7c0-3.434 3.137-6.183 6.737-5.354a.998.998 0 0 0 1.22-.891 8.52 8.52 0 0 0-2.467-6.757zm-7.491 13.002v.017a39 39 0 0 1-3.668.473 2.18 2.18 0 0 1-1.709-.624 2.16 2.16 0 0 1-.623-1.71c.387-4.715 1.444-8.358 2.83-9.744A6.5 6.5 0 0 1 15.462 2c1.747 0 3.389.68 4.623 1.915a6.53 6.53 0 0 1 1.892 4.103c-4.348-.287-7.969 3.194-7.969 7.485"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-drumstick-bite_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDrumstickBite;
